import * as React from 'react';

import './user-info.css';
import Steps from '../../common/steps';

import { StepItemData } from '../../types';

interface UserInfoStepsProps {
  activeId: number
}

class UserInfoSteps extends React.Component<UserInfoStepsProps, any> {
  // Lists all the steps in this page
  private data: StepItemData[] = [
    { title: 'Basic info' },
    { title: 'Educations' },
    { title: 'Job History' },
    { title: 'Mentor Programs' },
    { title: 'Finish!' }
  ];

  constructor(props: UserInfoStepsProps) {
    super(props);
  }

  public render() {
    return (
      <Steps
          activeId={this.props.activeId}
          id="user-info-steps"
          stepData={this.data}
      />
    );
  }
}

export default UserInfoSteps;



// WEBPACK FOOTER //
// ./src/pages/user-info/UserInfoSteps.tsx